module.exports = __webpack_public_path__ + "static/media/scheme5.98816761.png";